import React from 'react'
import Lpntable from './Components/Lpn-table'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'

const StockLedgerMain = () => {
  return (
    <div className='d-flex flex-column' style={{minHeight:'100vh'}}>
        <Header />
        <Lpntable />
        {/* <Footer /> */}
    </div>
  )
}

export default StockLedgerMain